import { Injectable, inject } from '@angular/core';
import {
	ICmmsFilesQueryVariables,
	IFilesWithPaginationData,
} from '@app/pages/cmms/interfaces/files.interfaces';
import { Apollo } from 'apollo-angular';
import { EMPTY, Observable, catchError, map, take } from 'rxjs';
import { FileImportQuery } from '../graphql/file-import.queries';
import { IImportedFilesWithPaginationResponse } from '../interfaces/file-import.interfaces';
import { deleteFileEntitiesMutation } from '../graphql/file-import.mutations';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { TranslateService } from '@tolgee/ngx';

@Injectable({
	providedIn: 'root',
})
export class FilesRepoService {
	private readonly apollo = inject(Apollo);
	private readonly notify = inject(IconSnackBarService);
	private readonly translateService = inject(TranslateService);

	filesQuery(
		importId: string,
		variables: ICmmsFilesQueryVariables
	): Observable<IFilesWithPaginationData> {
		return this.apollo
			.query<IImportedFilesWithPaginationResponse>({
				query: FileImportQuery,
				variables: {
					importId,
					...variables,
				},
				fetchPolicy: 'no-cache',
			})
			.pipe(
				map(response => {
					const files = response?.data?.importFiles;
					return {
						files: files.edges.map(edge => edge.node),
						filesPagination: {
							pageInfo: files.pageInfo,
							totalCount: files.totalCount,
						},
						fileImportCounters: files.fileImportCounters,
					} as IFilesWithPaginationData;
				}),
				take(1)
			);
	}

	deleteFiles(filePks: string[]) {
		return this.apollo
			.mutate({ mutation: deleteFileEntitiesMutation, variables: { files: filePks } })
			.pipe(
				take(1),
				map(res => {
					return res?.data?.deleteFiles?.success;
				}),
				catchError(() => {
					this.notify.error(this.translateService.instant('error_files_delete'));
					return EMPTY;
				})
			);
	}
}
